export const GLOBAL_PRICING_REGIONS = 'global_pricing_regions';
export const GLOBAL_PRICING_ID = 'global_pricing_id';
